module.exports = __webpack_public_path__ + "static/media/IconWarning.87f4926f.svg";